import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetInterfaceLang, addEmailTemplates, editEmailTemplates, getEmailTemplateOne, getEmailTemplates} from '../../actions/index';
import _ from 'lodash';

class PageEdit extends Component {
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props){
        super(props);
        this.SubmitForm = this.SubmitForm.bind(this);
        this.renderName = this.renderName.bind(this);
        this.removeClass = this.removeClass.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInterfaceLang(token);
        this.props.getEmailTemplates(token);
        this.props.getEmailTemplateOne(token, this.props.params.id_email);
    }
    componentWillUnmount(){
        this.props.email.email_one = {};
        this.props.email.email_temp = [];
    }
    edit(e){
        let block = $(e.target).data('id')
        $('#'+block+' .idetBlock').summernote({
                lang: "ru-RU",
                height: 150,
                dialogsInBody: true,
                toolbar: [
                    ["font", ["bold", "underline", "clear"]],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ["para", ["ul", "ol", "paragraph"]],
                    ["table", ["table"]],
                    ["insert", ["link", "picture", "video"]],
                    ["view", ["fullscreen", "codeview"]]
                ]
            });
        $('#'+block+' .btn-primary').show();
    };
    save(e){
        let block = $(e.target).data('id')
        let makrup = $('#'+block+' .idetBlock').summernote('code');
        $('#'+block+' .idetBlock').summernote('destroy');
        $('#'+block+' .btn-primary').hide();
        $('#'+block+' .idetBlock').closest('.addWordBlock').removeClass('has-error');
    };
    removeClass(e){
        $(e.target).parent().removeClass('has-error');
    }
    SubmitForm(){
        let token = localStorage.getItem('id_token_admin');
        let block = $('.row_for_translate');
        let arr = [];
        let props = {};
        for(let i=0; i<block.length; i++){
            let oneBlock = block[i];
            if($(oneBlock).find('input.title').val() != ''){
                if($(oneBlock).find('.idetBlock').html() != '' && $(oneBlock).find('.idetBlock').html() != '<p><br></p>'){
                    let obj={
                        content: $(oneBlock).find('.idetBlock').html(),
                        type: this.props.params.id_email,
                        blang: parseInt($(oneBlock).attr('id')),
                        title: $(oneBlock).find('input.title').val()
                    };
                    setTimeout(()=>{
                        if($('.formPage').find('.has-error').length > 0){return false}else{
                            if($(oneBlock).data('send') == 'patch'){
                                this.props.editEmailTemplates(token,$(oneBlock).data('id'), obj);
                            }else{
                                this.props.addEmailTemplates(token, obj);
                            }
                            this.context.router.push('/email_template');
                        }
                    },500)

                }else{
                    $(oneBlock).find('.idetBlock').closest('.addWordBlock').addClass('has-error');
                }
            }else{
                $(oneBlock).find('input.title').parent().addClass('has-error');
            }
        }
    }
    editTranslation(id){
        let that = this;
        if(this.props.params.id_email){
            let item = _.findWhere(this.props.email.email_one.results, {blang: id});
            if(_.findWhere(this.props.email.email_one.results, {blang: id})){
                return(
                    <div className="col-md-12 row_for_translate" data-send="patch" data-id={item.id} id={item.blang} key={item.blang}>
                        <div className="row">
                            <div className="col-md-4" id={item.blang}>
                                <label>Title</label>
                            </div>
                            <div className="col-md-4" id={item.blang}>
                                <input type="text" className="form-control title" defaultValue={item.title} onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row addWordBlock" id={'edit'+item.blang}>
                            <div className="col-md-4">
                                <label>Content</label>
                            </div>
                            <div className="col-md-4" data-name={'edit'+item.blang}>
                                <div className="idetBlock" dangerouslySetInnerHTML={{__html: item.content}}></div>
                                <div className="blockBtn">
                                    <button id="edit" data-id={'edit'+item.blang} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-id={'edit'+item.blang} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }else{
                return(
                    <div className="col-md-12 row_for_translate" data-send="post" id={id}>
                        <div className="row">
                            <div className="col-md-4" id={id}>
                                <label>Title</label>
                            </div>
                            <div className="col-md-4" id={id}>
                                <input type="text" className="form-control title" onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row addWordBlock" id={id}>
                            <div className="col-md-4">
                                <label>Content</label>
                            </div>
                            <div className="col-md-4" data-name={id}>
                                <div className="idetBlock"></div>
                                <div className="blockBtn">
                                    <button id="edit" data-id={id} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-id={id} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }else{
            return(
                <div className="col-md-12 row_for_translate" data-send="post" id={id}>
                    <div className="row">
                        <div className="col-md-4" id={id}>
                            <label>Title</label>
                        </div>
                        <div className="col-md-4" id={id}>
                            <input type="text" className="form-control title" onChange={this.removeClass}/>
                        </div>
                    </div>
                    <div className="row addWordBlock" id={id}>
                        <div className="col-md-4">
                            <label>Content</label>
                        </div>
                        <div className="col-md-4" data-name={item.lang.name}>
                            <div className="idetBlock"></div>
                            <div className="blockBtn">
                                <button id="edit" data-id={item.id} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                <button id="save" data-id={item.id} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
    getTitleById(id, translations) {
        let result = '';
        translations.forEach(function(item, i){
            if(item.type == id) {
                result = item.name;
            }
        });
        return result
    }
    renderName(id){
        return this.getTitleById(parseInt(id), this.props.email.email_temp);
    }
    renderTranslate(){
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item)=>{
            return(
                <div className="col-md-12" key={item.lang.id}>
                    <div className='row sentences' id={item.id}>
                        <div className="col-md-12">
                            <p className="name_language">{item.lang.name}</p>
                        </div>
                        {this.editTranslation(item.id)}
                    </div>
                </div>
            )
        });
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id_email && this.props.email.email_one ? <p className="dashboard-title">{this.renderName(this.props.params.id_email)}</p> : <p className="dashboard-title">w</p>}
                <p className="dashboard-text">Email template</p>
                {this.props.lang.interface_lang.results && this.props.email.email_one != undefined ?
                    <div className="formPage white-block clearfix">
                        {this.renderTranslate()}
                    </div>
                    : ""
                }
                <div className="white-block clearfix">
                    <div className="col-md-12 text-center button-group">
                        <Link to={"email_template"} className="btn btn-default">Back</Link>
                        <button type="button" onClick={this.SubmitForm} className="btn btn-primary">Save</button>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        email: state.email
    }
}
export default connect(mapStateToProps, {GetInterfaceLang, addEmailTemplates, editEmailTemplates, getEmailTemplateOne, getEmailTemplates})(PageEdit);



// WEBPACK FOOTER //
// ./src/components/email_template/emailEdit.js